<template>
  <div :class="alertClass">
    <slot></slot>  
  </div>
</template>
<script>
export default {
  name:'alert',
  props: {
    type: {
      type: String,
      default: 'warning',
    },
  },
  computed:{
    alertClass () {
      return 'alert alert-'+this.type
    }
  }
}
</script>